import { validateEmail as commonValidateEmail } from "../../lib/Util";

export const validateEmail = (email: string): string | boolean | undefined => {
  const re = /^.*@ingest.switchboard-software.com$/;
  if (!re.test(String(email))) {
    return "The domain must be @ingest.switchboard-software.com";
  }
  return commonValidateEmail(email);
};
